import { useWindowSize } from "@/Shared/Hooks/useWindowSize";

export function useIsAuthViewHeightTooSmall(): boolean {
  const { height } = useWindowSize();
  return height !== undefined && height < 650;
}
